import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, PrestacaoContasTiposReducer, PrestacaoContasTiposState } from "./prestacao-contas-tipos-reducer";

const PrestacaoContasTiposContext = createContext<PrestacaoContasTiposState | undefined>(undefined);
const PrestacaoContasTiposDispatchContext = createContext({} as any);

const PrestacaoContasTiposProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PrestacaoContasTiposReducer, {
        tipos: [],
        loading: false
    } as PrestacaoContasTiposState);

    return (
        <PrestacaoContasTiposContext.Provider value={state}>
            <PrestacaoContasTiposDispatchContext.Provider value={dispatch}>
                {children}
            </PrestacaoContasTiposDispatchContext.Provider>
        </PrestacaoContasTiposContext.Provider>
    );
}

const usePrestacaoContasTiposState = () => {
    const context = useContext(PrestacaoContasTiposContext);
    if (context === undefined) {
        throw new Error('usePrestacaoContasTiposState must be used within a PrestacaoContasTiposProvider');
    }
    return context;
}

const usePrestacaoContasTiposDispatch = () => {
    const context = useContext(PrestacaoContasTiposDispatchContext);
    if (context === undefined) {
        throw new Error('usePrestacaoContasTiposDispatch must be used within a PrestacaoContasTiposProvider');
    }
    return context;
}

export { PrestacaoContasTiposProvider, usePrestacaoContasTiposState, usePrestacaoContasTiposDispatch, ACTION_TYPES };
